/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch, SetStateAction, useContext, useEffect } from 'react'
import { StocksNatsConnect } from '@/components/Common/NatsProvider'

export default function useGetINStockLivePriceFromMultipleSockets(
  subjectArr: (string | undefined)[],
  setLivePrice: Dispatch<
    SetStateAction<
      Record<
        string,
        {
          price: number | undefined
          percChange: number | undefined
        }
      >
    >
  > | null,
) {
  const { nats: nc } = useContext(StocksNatsConnect)
  useEffect(() => {
    const natsSubsciptionArr: any[] = []
    async function init() {
      try {
        if (!!subjectArr.length && nc) {
          // Only connect if firebase_path is received from Backend
          const decoder = new TextDecoder()
          for (const subj of subjectArr) {
            if (subj) {
              natsSubsciptionArr.push(
                nc.subscribe(subj, {
                  callback: (err, msg) => {
                    const decodedData = JSON.parse(decoder.decode(msg.data))
                    if (setLivePrice) {
                      setLivePrice(prev => {
                        return {
                          ...prev,
                          [subj]: {
                            price: decodedData?.live_price,
                            percChange: decodedData?.perc_change_float,
                          },
                        }
                      })
                    }
                  },
                }),
              )
            }
          }
        }
      } catch (err: unknown) {
        // Do nothing
        // Socket reconnects if fails, incase it throws an error, no need to display any UI error messages for now, prices will remain static
        console.info('Socket connection failed', err)
      }
    }
    void init()
    return () => {
      if (!!natsSubsciptionArr.length) {
        natsSubsciptionArr.forEach(natsSubscription => {
          void natsSubscription?.unsubscribe()
        })
      }
    }
  }, [nc, setLivePrice, subjectArr])
}
